import React, { forwardRef, Fragment } from 'react';
import range from 'lodash/range';
import { default as GridRow } from './_partials/GridRow';
import { getGridConfiguration } from './helpers';
const Grid = /*#__PURE__*/ forwardRef(({ breakpoints , className , containerWidth , screenWidth , breakByScreenWidth =true , contentStrip , contentStripIndex , elementCount , enableScrollOptim =true , maxRows =Number.POSITIVE_INFINITY , spacing , withShadowSpace , onOffsetReached , getDuperbrowseItemId , getElementId , renderElement , rowAlign , preserveAspectRatio =true , adAfterNRow , adRenderer  }, ref)=>{
    const hasContentStrip = contentStrip !== undefined && contentStripIndex !== undefined;
    const { elementWidth , elementHeight , elementSpacing , elementsPerRow  } = getGridConfiguration({
        breakpoints,
        screenWidth,
        containerWidth,
        breakByScreenWidth,
        elementSpacing: spacing,
        preserveAspectRatio
    });
    const expectedRows = Math.ceil(elementCount / elementsPerRow);
    const rowCount = Math.min(maxRows, expectedRows);
    const shouldRenderAdForRow = (row)=>{
        return adAfterNRow && row > 0 && row % adAfterNRow === 0;
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        ref: ref
    }, range(rowCount).map((i)=>/*#__PURE__*/ React.createElement(Fragment, {
            key: `grid-row${i}`
        }, /*#__PURE__*/ React.createElement(GridRow, {
            key: `grid-row${i}`,
            rowIdx: i,
            contentStrip: hasContentStrip && contentStripIndex === i ? contentStrip : undefined,
            start: i * elementsPerRow,
            end: Math.min((i + 1) * elementsPerRow, elementCount),
            elementWidth: elementWidth,
            elementHeight: elementHeight,
            elementSpacing: elementSpacing,
            scrollOptims: enableScrollOptim,
            withShadowSpace: withShadowSpace,
            getDuperbrowseItemId: getDuperbrowseItemId,
            getElementId: getElementId,
            renderElement: renderElement,
            onOffsetReached: onOffsetReached,
            rowAlign: rowAlign
        }), shouldRenderAdForRow(i) && adRenderer && adRenderer(i))));
});
Grid.displayName = 'Grid';
export default Grid;
